import React from 'react';

import PropTypes from 'prop-types';
import { MdArrowBack } from 'react-icons/md';

import { appName, appNameShort } from '@shared';
import { S } from '@shared/components';

import styles from './Sidebar.less';

const stopPropagation = e => e.stopPropagation();

const SidebarTrigger = ({ collapsed }) => (
  <div className={styles.triggerWrapper}>
    <MdArrowBack
      className={styles.expandTrigger}
      id={collapsed ? 'qa_expand' : 'qa_collapse'}
    />
    <S size="6" bold className={styles.appName} onClick={stopPropagation}>
      {appName}
    </S>
    <S size="6" bold className={styles.appNameShort} onClick={stopPropagation}>
      {appNameShort}
    </S>
  </div>
);

SidebarTrigger.propTypes = {
  collapsed: PropTypes.bool.isRequired,
};

export default SidebarTrigger;
